import { createContext, useContext } from 'react';

import { ILpComponentContextualFields } from '../../declarations/contentful';

const StickyAddressContext = createContext<ILpComponentContextualFields | null>(null);

export const StickyAddressProvider = StickyAddressContext.Provider;
export const useStickyAddress = () => useContext(StickyAddressContext);
